export function isNotNull(x) {
    return x != null;
}
//# sourceMappingURL=utils.js.map